import React, { PureComponent } from 'react';
import { PropTypes as RPT } from 'prop-types';
import { Form, connectField, connectSubmit } from 'onion-form';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BasicInput from '../components/InputField.react';
import Checkbox from '../components/InputFieldCheckbox.react';
import Button from '../components/Button.react';
import ModalTerms from './modalTerms.react';
import Popup from './popup.react';

import { submitQuestionnaire as submitQuestionnaireAction } from '../../common/healthCheck/actions';

const isRequired = value => ((!value) ? 'required' : null);
const wrongEmailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
const emailWrongFormat = value => ((value && !value.match(wrongEmailPattern)) ? 'wrongFormat' : null);

const validations = {
  user_name: [isRequired],
  company_name: [isRequired],
  email: [isRequired, emailWrongFormat],
  terms: [isRequired],
};

const Email = connectField(
  'email',
  { type: 'text', placeholder: 'Váš e­mail', className: 'form-control' },
)(BasicInput);
const CompanyName = connectField(
  'company_name',
  { type: 'text', placeholder: 'Název firmy', className: 'form-control questionary-form__input' },
)(BasicInput);
const UserName = connectField(
  'user_name',
  {
    type: 'text',
    placeholder: 'Vaše jméno',
    className: 'form-control questionary-form__input',
  },
)(BasicInput);
const Terms = connectField(
  'terms',
  {
    type: 'checkbox',
    label: `Souhlasím se
      <a href="#modal-terms" data-toggle="modal" data-target="#modal-terms">
        <strong>zpracováním osobních údajů</strong>
      </a>`,
  },
)(Checkbox);

const Submit = connectSubmit(props => <Button {...props} type="submit" />);

class ResultForm extends PureComponent {
  static propTypes = {
    hasData: RPT.bool,
    history: RPT.object,
    match: RPT.object,
    submitStatus: RPT.any,
    questionnaireData: RPT.any,
    rehydrated: RPT.bool,
    submitQuestionnaire: RPT.func,
  }

  componentWillReceiveProps(nextProps) {
    const {
      hasData,
      history: { push },
      match,
      rehydrated,
    } = nextProps;

    if (!hasData && rehydrated) {
      const backLink = `/${match.params.field_id}/project-health-check`;
      push(backLink);
    }
  }

  onSubmit(values) {
    const { questionnaireData, submitQuestionnaire, match } = this.props;
    // TODO move code below into actions
    const results = questionnaireData.reduce((acc, data) => {
      acc[data.get('question_id')] = data.get('result');
      return acc;
    }, {});
    const { params: { field_id } } = match;

    const payload = {
      health_check_results: {
        ...values,
        results,
      },
    };

    submitQuestionnaire(payload, field_id);
  }

  render() {
    const { submitStatus } = this.props;

    return (
      <div className="questionary-form form-inline form-white">
        <h2 className="color-white">Odeslat výsledky auditu e-mailem</h2>
        <Form
          name="sendResults"
          onSubmit={({ values }) => this.onSubmit(values)}
          validations={validations}
        >
          <div className="form-group">
            <UserName />
          </div>
          <div className="form-group">
            <CompanyName />
          </div>
          <div className="form-group">
            <Email />
          </div>
          <Terms />
          <Submit className="btn btn-blind questionary__button">Odeslat výsledky</Submit>
        </Form>
        <Popup
          visible={submitStatus.toJS()}
          success="Úspěšně odesláno"
          error="Formulář se nepodařilo odeslat, zkuste to prosím znovu"
          className="succes-message"
        />
        <ModalTerms />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hasData: state.healthCheck.questionnaireData.size > 0,
  questionnaireData: state.healthCheck.questionnaireData,
  rehydrated: state.healthCheck.rehydrated,
  submitStatus: state.healthCheck.getIn(['ui', 'submit']),
});
const mapDispatchToProps = dispatch => bindActionCreators(
  {
    submitQuestionnaire: submitQuestionnaireAction,
  },
  dispatch,
);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ResultForm),
);
